"use client";
import { jsx as i } from "react/jsx-runtime";
import { focusOutline as s } from "../../common/styles/mixins/focusOutline.js";
import { square as u } from "../../common/styles/mixins/square.js";
import p from "../icon/Icon.js";
import { css as f } from "@emotion/react";
import n from "@emotion/styled";
import { COLORS as r } from "../../tokens/colors/Colors.js";
import { ICON_SIZES as y } from "../../tokens/icon-sizes/IconSizes.js";
import { forwardRef as b } from "react";
const d = b(
  ({ as: o, feColor: t = "gray", feIcon: c, feSize: a = "md", ...l }, m) => /* @__PURE__ */ i(
    h,
    {
      ...l,
      as: o,
      "data-comp": "icon-button",
      feColor: t,
      feSize: a,
      ref: m,
      children: /* @__PURE__ */ i(I, { feIcon: c, feSize: a })
    }
  )
);
d.displayName = "IconButton";
const E = d, e = Object.freeze({
  brand: {
    default: r.brand,
    disabled: r.gray500,
    hover: r.primary800
  },
  gray: {
    default: r.gray700,
    disabled: r.gray500,
    hover: r.black
  },
  white: {
    default: r.white,
    disabled: r.primary500,
    hover: r.primary200
  }
}), h = n.span(
  ({ feColor: o, feSize: t }) => {
    if (!o || !t)
      throw new Error("Style error");
    return f`
			${u(y[t])};

			color: ${e[o].default};
			display: inline-flex;

			&:focus-visible {
				${s({ color: e[o].default })}
			}

			&:hover {
				color: ${e[o].hover};
			}

			&:disabled {
				color: ${e[o].disabled};
			}
		`;
  }
), I = n(p)`
	color: inherit;
`;
export {
  E as default
};
